import { waitAsync } from '../utils';
import { Route } from 'react-router-dom';

const EntryMerchantAction = "ENTRY_MERCHANT";
const ModifyMerchantAction = "MODIFY_MERCHANT";
const Waiting = "WAITNG_ENTRIES";

const initialState = {
    nowWainting: false,
    editing: null,
};
export const actionCreators = {

    /**
     * 一般加盟店を申込
     */
    entry: (token, merchant) => async (dispatch) => {
        var routeurl = `api/user/entries/entry`;

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
//                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(merchant)
            })
            var addNew = true;

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();

                if (resp.error_message == null) {

                    dispatch({ type: EntryMerchantAction, merchant: resp.result, addNew });
                    return resp.result;

                } else {

                    throw new Error(resp.error_message || '申込に失敗しました。');

                }
            } else {
                throw new Error('申込に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 編集用のモデルをロードします。
     */
    loadEditModel: (token, merchantId) => async (dispatch) => {
        var routeurl = `api/user/entries/edit`;

        if (merchantId != null) {
            routeurl += `?id=${merchantId}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
//                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })
            const resultStatus = response.status;
            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    const merchant = resp.result;
                    dispatch({ type: ModifyMerchantAction, merchant });
                    return merchant;
                } else {
                    throw new Error(resp.error_message || '加盟店情報取得に失敗しました。');
                }
            } else {
                throw new Error('データ取得に失敗しました。');
            }
        }
        finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },


}

export const reducer = (state, action) => {
    state = state || initialState;
    
    if (action.type === Waiting) {
        return {
            ...state,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ModifyMerchantAction) {
        return {
            ...state,
            editing: action.merchant,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === EntryMerchantAction) {

        if (action.addNew) {
            // 加盟店の新規登録時の場合はリストに追加
            state.list.push(action.merchant);
        }
        else {
            // 変更の場合はリストを変更
            var idx = state.list.findIndex((o) => o.id == action.merchant.id);
            state.list[idx] = action.merchant;
        }

        return {
            ...state,
            editing: action.merchant
        };
    }
   return state;
}